// extracted by mini-css-extract-plugin
export default {"iframePlayer":"Stream_iframePlayer--G5Z","restrictedPlayerSize":"Stream_restrictedPlayerSize--XLV","errorContainer":"Stream_errorContainer--aT0"};